import styled from "styled-components";
import { Section } from "../../styled/index";

export const StyledFooter = styled.footer`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const StyledFooterWrap = styled(Section)``;
